/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IBanner {
  bannerImage?: string;
  bannerDescription?: string;
  bannerText?: string;
  halfBanner1?: string;
  halfBanner2?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class Banner extends Component {
  private readonly banner: IBanner = {
    bannerImage:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1UrF',
    bannerDescription: 'Play @ Home theater',
    bannerText:
      'Step right up for easy ways to have a blast at home! Mess around with no-mess coloring pages, try some DIYs, and get their brains workin’ in overdrive with puzzles, word searches and more. This is their stage and it’s their time to shine!',
    halfBanner1:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZYP',
    halfBanner2:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Xsq',
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='col-md-12'>
          <img
            className='img-responsive'
            src={this.banner.bannerImage}
            alt={this.banner.bannerDescription}
          />
        </div>
        <div className='col-md-12 p-home-container'>
          <p>{this.banner.bannerText}</p>
        </div>
        <div className='row'>
          <div className='col-md-6 p-home-small-banner'>
            <img
              className='img-responsive'
              src={this.banner.halfBanner1}
              alt={this.banner.bannerDescription}
            />
          </div>
          <div className='col-md-6 p-home-small-banner'>
            <img
              className='img-responsive'
              src={this.banner.halfBanner2}
              alt={this.banner.bannerDescription}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Banner;
